import { inject } from '@angular/core';
import { Router, CanActivateFn } from '@angular/router';
import { firstValueFrom, switchMap } from 'rxjs';
import { AuthService } from './auth.service';
import { PlanService } from './plan.service';
import { WelcomeWizardService } from './welcome-wizard.service';

export const rootRedirectGuard: CanActivateFn = () => {
  const router      = inject(Router);
  const authService = inject(AuthService);

  if (authService.isAuthenticated()) {
    return router.createUrlTree(['/launcher']);
  }
  return router.createUrlTree(['/login']);
};

export const AdminGuard: CanActivateFn = (route, state) => {
  const router         = inject(Router);
  const authService    = inject(AuthService);
  const planService    = inject(PlanService);
  const wizardService  = inject(WelcomeWizardService);

  if (!authService.isAuthenticated()) {
    router.navigate(['/login']);
    return false;
  }
  authService.authenticated();

  return authService.validateTokenWithServer().pipe(
    switchMap(async (ok) => {
      if (!ok) {
        if (!authService.isAuthenticated()) return false;
        router.navigate(['/login']);
        return false;
      }

      await planService.loadOnce();

      if (planService.isSolo() && state.url.startsWith('/moni')) {
        return router.createUrlTree(['/solo', 'dashboard']);
      }

      return firstValueFrom(wizardService.checkForGuard(state.url));
    })
  );
};
